import { render, staticRenderFns } from "./StatisticsNew.vue?vue&type=template&id=a334f972&scoped=true&"
import script from "./StatisticsNew.vue?vue&type=script&lang=ts&"
export * from "./StatisticsNew.vue?vue&type=script&lang=ts&"
import style0 from "./StatisticsNew.vue?vue&type=style&index=0&id=a334f972&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a334f972",
  null
  
)

export default component.exports